<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="drop_hint" @click="showModal">
                    <div class="main_btn">
                        <div  class="d-flex align-items-center">
                            <SvgHeaderSvg  :type="'email'" />
                            <span class="ms-3"> Drop a hint</span>
                        </div>
                        <div class="tooltip_box">
                            <SvgHeaderSvg class="ms-1" :type="'info'" />
                            <div class="tooltip_text tooltip_text_mod">Send selection details to your loved one by filling out this form.</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Modal -->
                <div v-if="flagShowModal">
                    <Teleport  to="#teleports">
                    <div class="modal fade" id="drophint" data-bs-backdrop="true" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" ref="myModalRef">
                        <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-body">

                            <form enctype="multipart/form-data" ref="moment_form" @submit.prevent="submit">
                                    <div class="title_block">
                                        <div>
                                        <h5 class="modal-title font-active" id="exampleModalLabel">Drop a hint</h5>
                                        </div>
                                        
                                        <span @click="hideModal"><SvgHeaderSvg type="close" class="largesvg" /></span>
                                    </div>
                                    <p>Send selection details to your loved one by filling the form below. </p>
        
                                <div class="row mt-4 moment_form" role="group">
                                    <div class="col-md-12 pb-3 column">
                                        <label class="mb-2">Your Name *</label>
                                        <input name="name" required :class="{ 'is-invalid':errorMessages.your_name }" type="text" v-model="formData.your_name"   />
                                        <span v-if="errorMessages.your_name" class="error-msg">{{ errorMessages.your_name.join(' ') }}</span>
                                    </div>
        
                                    <div class="col-md-12 pb-3 column">
                                        <label class="mb-2">Your Email Address *</label>
                                        <input name="email" required :class="{ 'is-invalid': errorMessages.your_email }" type="email" v-model="formData.your_email" />
                                        <span v-if="errorMessages.your_email" class="error-msg">{{ errorMessages.your_email.join(' ') }}</span>
                                    </div>
        
                                    <div class="col-md-12 pb-3 column">
                                        <label class="mb-2">Partner's Name *</label>
                                        <input name="partners_name" required :class="{ 'is-invalid': errorMessages.partners_name }" type="text" v-model="formData.partners_name" />
                                        <span v-if="errorMessages.partners_name" class="error-msg">{{ errorMessages.partners_name.join(' ') }}</span>
                                    </div>
        
                                    <div class="col-md-12 pb-3 column">
                                        <label class="mb-2">Partners Email Address *</label>
                                        <input name="partners_email" required :class="{ 'is-invalid': errorMessages.partners_email }" type="email" v-model="formData.partners_email" />
                                        <span v-if="errorMessages.partners_email" class="error-msg">{{ errorMessages.partners_email.join(' ') }}</span>
                                    </div>
        
                                    <div class="col-md-12 pb-3 column">
                                        <div class="textarea_box">
                                            <label for="">Your Message</label>
                                            <textarea size="lg" name="message" rows="8" maxlength="512" :class="{'invalid': errorMessages.your_message}" placeholder="" v-model="formData.your_message"/>
                                            <span v-if="errorMessages.your_message" class="error-msg">{{ errorMessages.your_message.join(" ") }}</span>
                                            <p class="mb-0"> {{formData.your_message.length}}/512 characters</p>
                                        </div>
                                    </div>
                                    
                                    <div class="col-md-12 pb-3 column">
                                        <div class="filter_row mb-2">
                                            <div class="checkbox_custom ms-0" @click="formData.self_copy = !formData.self_copy">
                                                <span :class="{ 'checked' : formData.self_copy === true || formData.self_copy === 1,  'unchecked' : formData.self_copy === false || formData.self_copy === 0 }"></span>
                                                <label class="mb-0">Send a copy of this email to me</label>
                                            </div>
                                        </div>
                                        <div class="filter_row">
                                            <div class="checkbox_custom ms-0" @click="formData.newsletter = !formData.newsletter">
                                                <span :class="{ 'checked' : formData.newsletter === true || formData.newsletter === 1,  'unchecked' : formData.newsletter === false || formData.newsletter === 0 }"></span>
                                                <label class="mb-0">Send me updates on new styles and special offers</label>
                                            </div>
                                        </div>
                                    </div>
        
                                    <div v-if="!showSuccess" class="col-md-12 pb-3">
                                        <CommonBasePrimary disabled v-if="showLoader">please wait...</CommonBasePrimary>
                                        <CommonBasePrimary v-else type="submit">submit</CommonBasePrimary>
                                    </div>
        
                                    <div v-if="showSuccess" class="col-md-12 pb-4">
                                        <div class="alert alert-primary mb-0" role="alert">Request successfully submitted </div>
                                    </div>
                                </div>
                            </form>
                            </div>
                        </div>
                        </div>
                    </div>
                </Teleport>
             </div>
        </div>
    </div>
</template>

<script setup>
    const route = useRoute();
    const props = defineProps(['data'])
    const showLoader = ref(false)
    const flagShowModal = ref(false);
    const myModalRef = ref(null);
    const formData = reactive({
        // ---default----
        your_name: '',
        your_email: '',
        partners_name: '',
        partners_email: '',
        your_message: '',
        self_copy: false,
        newsletter: true,
        status:1,

        // ----- product wise----
        module_type:'',
        item_type:null,
        setting_id: null,
        loose_id: null,
        loose_two_id: null
    })

    const errorMessages = ref({});
    const showSuccess = ref(false);

    const emptyData = () => {
         // ---default----
        formData.your_name= '',
        formData.your_email= '',
        formData.partners_name= '',
        formData.partners_email= '',
        formData.your_message= '',
        formData.self_copy= false,
        formData.newsletter= true,
        formData.status=1
        // ----- product wise----
        // formData.module_type='',
        formData.item_type=null,
        // formData.setting_id= null,
        // formData.loose_id= null,
        formData.loose_two_id= null,
        formData.loose_two_id= null
    }

    const showModal = () => {
        flagShowModal.value = true;
        nextTick(() => {
        const modalElement = myModalRef.value;
        if (modalElement) {
        const modalInstance = new bootstrap.Modal(modalElement);
        modalInstance.show();
        }
        });
    };


    const hideModal = () => {
        const modalElement = myModalRef.value;
        if (modalElement) {
            const modalInstance = bootstrap.Modal.getInstance(modalElement);
            if (modalInstance) {
                modalInstance.hide();
            }
        }
        flagShowModal.value = false;
    };

    const checkZeroOne =(data)=>{
        for (const key of Object.keys(data)) {
            if(data[key] === true){
                data[key] = 1
            }
            if(data[key] === false){
                data[key] = 0
            }
        }
    }

    const submit = async () => {
        errorMessages.value = {};
        showLoader.value = true;
        checkZeroOne(formData)

        try {
            const response = await $fetch(useCountryPath('/drop-hint/store'), {
               method: 'POST',
                body: formData            
             })
            if (response.success) {
   
                showSuccess.value = true
                emptyData()
                setTimeout(() => {
                    flagShowModal.value = false
                    showSuccess.value = false
                    showLoader.value = false
                    hideModal()
                }, 2000);
            }
        } 

        catch (errors) {
            showLoader.value = false;
  

            if (errors.data && errors.data.errors) {
                errorMessages.value = errors.data.errors;  
            } 
            if (errors.success === false) {
            toast('success', "Something went wrong, Please contact admin");
        }
    }
    }

    onMounted(() => {
    showSuccess.value = false
        
    // -----webshop-----
    if(route.name.includes('shop-detail')){
      formData.module_type = 'shop'
      formData.item_type = props.data.sub_type
      formData.setting_id = props.data.id
    }

    // -----cyor-----
    if(route.name.includes('cyo-setting-detail-ring')){
      formData.module_type = 'cyor'
      formData.setting_id = props.data.id
    }
    if(route.name.includes('cyo-diamond-detail-ring')){
      formData.module_type = 'cyor'
      formData.loose_id = props.data.id
    }
    if(route.name.includes('cyo-complete-ring')){
      formData.module_type = 'cyor'
      formData.setting_id = props.data.setting.id
      formData.loose_id = props.data.diamond.id
    }

    // -----cyop-----
    if(route.name.includes('cyo-setting-detail-pendant')){
      formData.module_type = 'cyop'
      formData.setting_id = props.data.id
    }
    if(route.name.includes('cyo-diamond-detail-pendant')){
      formData.module_type = 'cyop'
      formData.loose_id = props.data.id
    }
    if(route.name.includes('cyo-complete-pendant')){
      formData.module_type = 'cyop'
      formData.setting_id = props.data.setting.id
      formData.loose_id = props.data.diamond.id
    }

    // -----cyoe-----
    if(route.name.includes('cyo-setting-detail-earring')){
      formData.module_type = 'cyoe'
      formData.setting_id = props.data.id
    }
    if(route.name.includes('cyo-diamond-detail-earring')){
      formData.module_type = 'cyoe'
      formData.loose_id = props.data.stone_one_id
      formData.loose_two_id = props.data.stone_two_id
    }
    if(route.name.includes('cyo-complete-earring')){
      formData.module_type = 'cyoe'
      formData.setting_id = props.data.setting.id
      formData.loose_id = props.data.diamond.stone_one_id
      formData.loose_two_id = props.data.diamond.stone_two_id
    }

    // -----loose-----
    if(route.name.includes('loose-detail')){
      formData.module_type = 'loose'
      formData.loose_id = props.data.id
    }
    if(route.name.includes('preset-detail')){
      formData.module_type = 'preset'
      formData.setting_id = props.data.id
      formData.loose_id = null
    }
    })

</script>


<style scoped>


input{
    border-radius: 4px;
    font-size: 16px ;
}

textarea {
    border-radius: 4px;
    font-size: 16px;
}

.tooltip_box .svg-head {
    height: 22px;
    width: 20px;
}


.modal-content{
    padding: 2%;
    border-radius: 8px;
}
.tooltip_text.tooltip_text_mod {
    cursor: auto;
}
.checkbox_custom {
    font-size: 14px;
    font-weight: 600;
}
.check_box_hint label {
    font-weight: 600;
}
span{
    color: #363030;
    font-size: 14px;
    font-weight: 600;
}
.gemo_box{
    cursor: pointer;
}
.title_block{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
p {
    font-size: 16px;
    margin-bottom: 0;
    padding-top: 9px;
    color: #606060;
}
.title_block span {
    cursor: pointer;
}
.title_block h5 {
    font-size: 20px;
}
.drop_hint {
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    padding: 13px 15px;
    height: 50px;
}
.main_btn{
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}

.largesvg {
    transform: scale(1.3);
    }


@media(max-width: 1024px){
    .tooltip_box .tooltip_text{
        margin-left: -140px;
    }
}
</style>
